import { Link, useNavigate } from "react-router-dom";
import "./home.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import SwiperCore, { Autoplay } from "swiper/core";
import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { useForm } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import Header from "../components/Header";

function Home() {
    SwiperCore.use([Autoplay]);
    
    const swiperParams = {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        loop: true
    };
    
    // Đã chỉnh sửa lại params này để hiển thị đúng 4 game 1 hàng như ảnh
    const swiperGame5 = {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        grabCursor: true,
        breakpoints: {
            // Tự động thu nhỏ trên điện thoại nếu cần
            320: { slidesPerView: 2, spaceBetween: 10 },
            768: { slidesPerView: 3, spaceBetween: 15 },
            1024: { slidesPerView: 4, spaceBetween: 20 },
        }
    };

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")));
    const [bet, setBet] = useState(JSON.parse(localStorage.getItem("xsmb")));
    const [game, setGame] = useState(null);
    const [title, setTitle] = useState(null);
    const [isShow, setShow] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile != res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
            
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {}).then((res) => {
            if (notify != res.data.data) {
                setNotify(res.data.data);
                localStorage.setItem("notify", JSON.stringify(res.data.data));
            }
        });

        axios.get(`https://vnlottery.net/api/front/open/lottery/history/list/game?limitNum=5&gameCode=miba`).then((res) => {
            setBet(res.data.t);
            if (bet != res.data.t) {
                setBet(res.data.t);
                localStorage.setItem("xsmb", JSON.stringify(res.data.t));
            }
        });
       
    }, []);

    const date0 = new Date();
    const currentHour = date0.getHours();
    const [dateMT, setDateMT] = useState(date0.getDay());
    const [dataMT, setDataMT] = useState();
    const [imageMT, setImageMT] = useState([]);
    const handleChangeMT = (e) => {
        setDateMT(e.target.value);
    };

    const [dateMN, setDateMN] = useState(date0.getDay());
    const [dataMN, setDataMN] = useState([]);
    const [imageMN, setImageMN] = useState([]);
    const handleChangeMN = (e) => {
        setDateMN(e.target.value);
    };

    // Giữ nguyên các useEffect tính lô tô của bạn...
    useEffect(() => {
        if (dateMT == 0) {
            if (currentHour < 18) {
                setDataMT(["khho", "kotu", "thth"]);
                setImageMT(["khanhhoa", "komtum", "hue"]);
            } else {
                setDataMT(["phye", "thth"]);
                setImageMT(["phuyen", "hue"]);
            }
        }
        if (dateMT == 1) {
            if (currentHour < 18) {
                setDataMT(["phye", "thth"]);
                setImageMT(["phuyen", "hue"]);
            } else {
                setDataMT(["dalak", "quna"]);
                setImageMT(["daklak", "quangnam"]);
            }
        }
        if (dateMT == 2) {
            if (currentHour < 18) {
                setDataMT(["dalak", "quna"]);
                setImageMT(["daklak", "quangnam"]);
            } else {
                setDataMT(["dana", "khho"]);
                setImageMT(["danang", "khanhhoa"]);
            }
        }
        if (dateMT == 3) {
            if (currentHour < 18) {
                setDataMT(["dana", "khho"]);
                setImageMT(["danang", "khanhhoa"]);
            } else {
                setDataMT(["qubi", "bidi", "qutr"]);
                setImageMT(["quangbinh", "binhdinh", "quangtri"]);
            }
        }
        if (dateMT == 4) {
            if (currentHour < 18) {
                setDataMT(["qubi", "bidi", "qutr"]);
                setImageMT(["quangbinh", "binhdinh", "quangtri"]);
            } else {
                setDataMT(["gila", "nith"]);
                setImageMT(["gialai", "ninhthuan"]);
            }
        }
        if (dateMT == 5) {
            if (currentHour < 18) {
                setDataMT(["gila", "nith"]);
                setImageMT(["gialai", "ninhthuan"]);
            } else {
                setDataMT(["dana", "qung", "dano"]);
                setImageMT(["danang", "quangngai", "daknong"]);
            }
        }
        if (dateMT == 6) {
            if (currentHour < 18) {
                setDataMT(["dana", "qung", "dano"]);
                setImageMT(["danang", "quangngai", "daknong"]);
            } else {
                setDataMT(["khho", "kotu", "thth"]);
                setImageMT(["khanhhoa", "komtum", "hue"]);
            }
        }
    }, [dateMT]);

    useEffect(() => {
        if (dateMN == 0) {
            if (currentHour < 17) {
                setDataMN(["dalat", "kigi", "tigi"]);
                setImageMN(["dalat", "kiengiang", "tiengiang"]);
            } else {
                setDataMN(["cama", "doth", "tphc"]);
                setImageMN(["camau", "dongthap", "tphcm"]);
            }
        }
        if (dateMN == 1) {
            if (currentHour < 17) {
                setDataMN(["cama", "doth", "tphc"]);
                setImageMN(["camau", "dongthap", "tphcm"]);
            } else {
                setDataMN(["bali", "vuta", "betr"]);
                setImageMN(["baclieu", "vungtau", "bentre"]);
            }
        }
        if (dateMN == 2) {
            if (currentHour < 17) {
                setDataMN(["bali", "vuta", "betr"]);
                setImageMN(["baclieu", "vungtau", "bentre"]);
            } else {
                setDataMN(["cath", "dona", "sotr"]);
                setImageMN(["cantho", "dongnai", "soctrang"]);
            }
        }
        if (dateMN == 3) {
            if (currentHour < 17) {
                setDataMN(["cath", "dona", "sotr"]);
                setImageMN(["cantho", "dongnai", "soctrang"]);
            } else {
                setDataMN(["angi", "bith", "tani"]);
                setImageMN(["angiang", "binhthuan", "tayninh"]);
            }
        }
        if (dateMN == 4) {
            if (currentHour < 17) {
                setDataMN(["angi", "bith", "tani"]);
                setImageMN(["angiang", "binhthuan", "tayninh"]);
            } else {
                setDataMN(["bidu", "trvi", "vilo"]);
                setImageMN(["binhduong", "travinh", "vinhlong"]);
            }
        }
        if (dateMN == 5) {
            if (currentHour < 17) {
                setDataMN(["bidu", "trvi", "vilo"]);
                setImageMN(["binhduong", "travinh", "vinhlong"]);
            } else {
                setDataMN(["biph", "hagi", "loan", "tphc"]);
                setImageMN(["binhphuoc", "haugiang", "longan", "tphcm"]);
            }
        }
        if (dateMN == 6) {
            if (currentHour < 17) {
                setDataMN(["biph", "hagi", "loan", "tphc"]);
                setImageMN(["binhphuoc", "haugiang", "longan", "tphcm"]);
            } else {
                setDataMN(["dalat", "kigi", "tigi"]);
                setImageMN(["dalat", "kiengiang", "tiengiang"]);
            }
        }
    }, [dateMN]);

    const [loading, setLoading] = useState(false);
    function isMobileDevice() {
        if (window.innerWidth < 800) {
            return true;
        }
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {}).then((res) => {
            setProfile(res.data.data);
            localStorage.setItem("profile", JSON.stringify(res.data.data));
        });
    }, []);

    function launchGame(params) {
        if (localStorage.getItem("profile") == null || localStorage.getItem("profile") == "undefined") {
            navigate("/login");
            return;
        }
        if (loading == true) return;
        const form = {
            ...params,
            platform: isMobileDevice == true ? "html5" : "html5-desktop"
        };
        setLoading(true);
        let a;
        switch (params.product_type) {
            case "4": a = "AG"; break;
            case "79": a = "BBIN"; break;
            case "104": a = "CMD"; break;
            case "16": a = "CQ9"; break;
            case "27": a = "DG"; break;
            case "86": a = "Evolution"; break;
            case "142": a = "FB"; break;
            case "140": a = "JILI"; break;
            case "121": a = "KingMaker"; break;
            case "102": a = "V8 Poker"; break;
            case "123": a = "King Poker"; break;
            case "43": a = "MG"; break;
            case "39": a = "PP"; break;
            case "174": a = "SABA"; break;
            case "118": a = "WM"; break;
            case "112": a = "SEXY"; break;
            case "54": a = "SBO"; break;
            case "151": a = "UG"; break;
            case "99": a = "TF"; break;
            case "111": a = "Playtech"; break;
            case "28": a = "AllBet"; break;
            case "55": a = "JDB"; break;
            case "202": a = "WS168"; break;
            case "61": a = "IMES"; break;
            case "132": a = "SV388"; break;
            default: a = ""; break;
        }
        setSanh(a);
        setProduct(params.product_type);
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/launchgame`, form)
            .then((res) => {
                if (res.data.data.status == 0) {
                    setPlayGame(res.data.data.game_url);
                    axios
                        .post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: params.product_type })
                        .then((res) => {
                            setBalance(res.data.data.balance);
                            setLoading(false);
                        })
                        .catch((err) => swal("Đã xảy ra lỗi", "Vui lòng đăng xuất và đăng nhập lại", "error"));
                } else {
                    setLoading(false);
                    swal("Sảnh đang bảo trì", "Vui lòng chọn sảnh khác", "error");
                }
            })
            .catch((err) => {
                setLoading(false);
                if (err.response.data.data.tokenVerificationData.access == false) {
                    swal("Đã xảy ra lỗi", "Vui lòng đăng xuất và đăng nhập lại", "error");
                    return;
                }
                swal("Thất bại", err.response.data.message != "internal server error" ? err.response.data.message : "Đã có lỗi xảy ra", "error");
            });
    }

    const [profile, setProfile] = useState(null);
    const [playGame, setPlayGame] = useState(null);
    const { register, handleSubmit } = useForm();
    const [newMoney, setNewMoney] = useState(null);
    const [balance, setBalance] = useState(0);
    const [sanh, setSanh] = useState(null);
    const [product, setProduct] = useState(null);
    const [type, setType] = useState(null);
    const [load, setLoad] = useState(false);

    const onSubmit = (data) => {
        if (load === false) {
            if (!sanh) {
                swal("Thông báo", "Vui lòng chọn sảnh", "warning");
                return;
            }
            const formData = {
                product_type: product,
                type: type,
                money: Number(data.money.replaceAll(".", "").replaceAll(",", ""))
            };
            if (!type) {
                swal("Chú ý", "Vui lòng chọn chuyển tiền vào hoặc chuyển tiền ra", "warning");
                return;
            }
            setLoad(true);
            axios
                .post(`${process.env.REACT_APP_API_URL}/casino/transfer`, formData)
                .then((res) => {
                    if (type == "2") {
                        swal("Thành công", `Chuyển quỹ ra khỏi sảnh thành công!`, "success").then(() => window.location.reload());
                    } else {
                        swal("Thành công", `Chuyển quỹ vào sảnh thành công!`, "success").then(() => window.location.reload());
                    }
                    axios
                        .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
                        .then((res) => {
                            setProfile(res.data.data);
                        })
                        .catch((err) => localStorage.removeItem("user"));
                    setLoad(false);
                })
                .catch((err) => {
                    swal("Thất bại", err.response.data.message != "internal server error" ? err.response.data.message : "Đã xảy ra lỗi", "error");
                    setLoad(false);
                });
        }
    };

    const selectAll = (e) => {
        if (type == 1) {
            setNewMoney(profile.money > 0 && Math.floor(profile.money).toLocaleString("vi-VN"));
        } else if (type == 2) {
            balance > 0 && setNewMoney(Math.floor(balance).toLocaleString("vi-VN"));
        } else {
            swal("Chú ý", "Vui lòng chọn chuyển tiền vào hoặc chuyển tiền ra", "warning");
        }
    };

    const openGame = () => {
        window.location.href = playGame;
    };

    const menuGame = (title, product_type, game_type) => {
        setTitle(title);
        setLoading(true);
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/getgamelist`, { product_type, game_type })
            .then((res) => {
                if (res.data.data.length == 0) {
                    swal("Thông báo", "Sảnh game bảo trì", "error");
                    setLoading(false);
                } else {
                    setGame(res.data.data[0]);
                    setLoading(false);
                    setShow(true);
                }
            })
            .catch((err) => {
                swal("Thông báo", "Sảnh game bảo trì", "error");
                setLoading(false);
            });
    };

    const [yoGame, setYoGame] = useState(false);
    const [yoPopup, setYoPopup] = useState(false);
    const [yoType, setYoType] = useState(1);
    const [yoMoney, setYoMoney] = useState(0);
    const [yoBalance, setYoBalance] = useState(0);

    const openYoGame = () => {
        if (profile === null) {
            return navigate("/login");
        }
        setLoading(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/logingame`)
            .then((res) => {
                setYoGame(res.data.data);
                setYoBalance(res.data.data?.AccountInfo?.Balance);
                setYoPopup(true);
                setLoading(false);
            })
            .catch((err) => {
                swal("Thất bại", err.response.data.message != "internal server error" ? err.response.data.message : "Đã xảy ra lỗi", "error");
                setLoading(false);
            });
    };

    const [isSubmitting, setIsSubmitting] = useState(false);

    const submitYoGame = async () => {
        if (profile === null) {
            return navigate("/login");
        }
        if (isSubmitting) {
            return swal("Thông báo", "Bạn thao tác quá nhanh", "warning");
        }
        setLoading(true);
        const transactionAmount = Number(yoMoney?.replaceAll(".", "")?.replaceAll(",", ""));
        if (transactionAmount < 0) {
            setLoading(false);
            return swal("Chú ý", "Vui lòng nhập số tiền cần giao dịch", "warning");
        }
        const formData = {
            amount: transactionAmount,
            type: yoType
        };
        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/transfergame`, formData)
            .then((res) => {
                axios
                    .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
                    .then((res) => {
                        setProfile(res.data.data);
                        localStorage.setItem("profile", JSON.stringify(res.data.data));
                    })
                    .catch((err) => localStorage.removeItem("user"));
                swal(yoType == 1 ? "Nạp tiền thành công" : "Rút tiền thành công", "", "success");
                setYoBalance(res.data.data.new_balance);
                setTimeout(() => {
                    setIsSubmitting(false);
                }, 3000);
                setLoading(false);
            })
            .catch((err) => {
                swal("Thất bại", err.response.data.message != "internal server error" ? err.response.data.message : "Đã xảy ra lỗi", "error");
                setLoading(false);
                setIsSubmitting(false);
            });
    };

    return (
        <>
            <Header profile={profile} />
            {loading == true ? (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            ) : null}

            <div className="banner-wrapper">
                {swiperParams && notify ? (
                    <div className="box-slide" style={{ overflow: "hidden" }}>
                        <Swiper {...swiperParams} className="banner-list">
                            {notify.map((item, index) => {
                                if (index > 1 && item.title !== "marquee" && item.title !== "popup" && item.isShow === true) {
                                    return (
                                        <SwiperSlide key={index}>
                                            <div>
                                                <img 
                                                    className="carousel-item" 
                                                    alt={item.title.replace("}", "").replace("{", "")} 
                                                    src={item.image} 
                                                />
                                            </div>
                                        </SwiperSlide>
                                    );
                                }
                                return null;
                            })}
                        </Swiper>
                    </div>
                ) : null}
                
                <div className="swiper-pagination"></div>
                <div className="banner-button-prev"></div>
                <div className="banner-button-next"></div>
                
{notify && notify.length > 0 ? (
    <>
        {notify[0].isShow === true && notify[0].title === "marquee" ? (
            <div className="marquee-wrapper">
                <div className="container marquees" style={{ display: "flex", alignItems: "center" }}>
                    
                    <div className="marquee-img"></div>
                    <span className="marquee-text" style={{ marginRight: "10px" }}> :</span>
                    
                    {/* Dùng thẳng thẻ marquee để tự động chạy không cần CSS */}
                    <marquee 
                        direction="left" 
                        scrollamount="5" 
                        style={{ flex: 1, color: "#fff", marginTop: "4px" }}
                    >
                        <span dangerouslySetInnerHTML={{ __html: notify[0].content }} />
                    </marquee>

                </div>
            </div>
        ) : null}
    </>
) : null}
            </div>

            <main id="main">
                <div className="step-wrapper">
                    <div className="container">
                        <ul className="step-list">
                            <li className="step-item step_join">
                                <Link>
                                    <span>1</span>
                                    <div className="step-item-text">
                                        <h2>Tham gia</h2>
                                        <span>Đăng ký và tham gia KIMSA.</span>
                                    </div>
                                </Link>
                            </li>
                            <li className="step-item step_login">
                                <Link>
                                    <span>2</span>
                                    <div className="step-item-text">
                                        <h2>Tiền gửi</h2>
                                        <span>Nạp tiền vào ví của bạn và nhận tiền thưởng.</span>
                                    </div>
                                </Link>
                            </li>
                            <li className="step-item step_login">
                                <Link>
                                    <span>3</span>
                                    <div className="step-item-text">
                                        <h2>Chơi và thắng</h2>
                                        <span>Chơi các trò chơi yêu thích của bạn và trở thành người chiến thắng.</span>
                                    </div>
                                </Link>
                            </li>
                            <li className="right-item">
                                <Link>
                                    <img className="svg step-img" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/deposit-procedure.png" alt="" />
                                    <div className="right-item-text">
                                        <h2 className="right-item-top">Thủ tục gửi tiền</h2>
                                        <span className="right-item-button">Nhấn vào đây để xem phương thức gửi tiền.</span>
                                    </div>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="main-center-wrapper">
                    <div className="container">
                        <div className="main-center-content">
                            
                          
                          {/* --- THÊM ĐOẠN STYLE NÀY ĐỂ FIX LỖI MÉO ẢNH VÀ CHỮ TO --- */}
<style>{`
    /* 1. Fix lỗi ảnh bị méo */
    .recommend-games .recommend-game-items > img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important; /* Thuộc tính này giúp ảnh không bị méo */
        object-position: center top;
        display: block;
    }

    /* 2. Fix lỗi chữ "Chơi ngay" quá to */
    .recommend-games .recommend-button .play-btn {
        font-size: 14px !important; /* Ép cỡ chữ nhỏ lại */
        padding: 8px 20px !important; /* Căn lề nút cho gọn */
        white-space: nowrap !important; /* Không cho chữ rớt dòng */
        line-height: normal !important;
        min-width: unset !important;
        height: auto !important;
    }

    /* Đảm bảo khung chứa nút ở giữa màn hình khi hover */
    .recommend-games .recommend-button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
`}</style>

<div className="top-slots-wrapper">
    <div className="recommend-carousel">
        <div className="recommend-carousel-wrapper">
            <span className="recommend-popular-text"></span>
            <Swiper 
                autoplay={{ delay: 3500, disableOnInteraction: false }}
                loop={true}
                className="recommend-carousel-list"
            >
                <SwiperSlide className="recommend-wrapper">
                    <div className="recommend-content">
                        <div className="recommend-logo">
                            <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/title-promotion.png" alt="" />
                        </div>
                        <div className="recommend-center-img">
                            <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/promotion.png" alt="" />
                        </div>
                        <span className="recommend-text">
                            Với số lượng lớn các máy đánh bạc khác nhau và trải nghiệm chơi game hoàn chỉnh.
                        </span>
                    </div>
                    <img className="recommend-game-bg carousel-item" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/bg-sport.png" alt="" />
                </SwiperSlide>
                
                <SwiperSlide className="recommend-wrapper">
                    <Link >
                        <div className="recommend-content">
                            <div className="recommend-logo">
                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/title.png" alt="" />
                            </div>
                            <div className="recommend-center-img">
                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/sport.png" alt="" />
                            </div>
                            <span className="recommend-text">
                                Phong cách của slot này không gì khác ngoài sự may mắn của Trung Quốc.<br /> Vận may tối cao là một trò chơi 5 cuộn và 20 dòng.
                            </span>
                        </div>
                        <img className="recommend-game-bg carousel-item" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/bg-sport.png" alt="" />
                    </Link>
                </SwiperSlide>
                
                <SwiperSlide className="recommend-wrapper">
                    <Link >
                        <div className="recommend-content">
                            <div className="recommend-logo">
                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/title-casino.png" alt="" />
                            </div>
                            <div className="recommend-center-img">
                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/casino.png" alt="" />
                            </div>
                            <span className="recommend-text">
                                Đặt tất cả 5 biểu tượng Thần theo bất kỳ thứ tự nào trên một dòng thanh toán đang hoạt động để giành được x200 tiền cược dòng của bạn!
                            </span>
                        </div>
                        <img className="recommend-game-bg carousel-item" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/bg-sport.png" alt="" />
                    </Link>
                </SwiperSlide>
                
                <SwiperSlide className="recommend-wrapper">
                    <Link>
                        <div className="recommend-content">
                            <div className="recommend-logo">
                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/title-slot.png" alt="" />
                            </div>
                            <div className="recommend-center-img">
                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/slot.png" alt="" />
                            </div>
                            <span className="recommend-text">
                                Giữ và quay để nhận phần thưởng lên tới x250 trên tổng số tiền đặt cược.
                            </span>
                        </div>
                        <img className="recommend-game-bg carousel-item" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/bg-sport.png" alt="" />
                    </Link>
                </SwiperSlide>
                
                <SwiperSlide className="recommend-wrapper">
                    <Link>
                        <div className="recommend-content">
                            <div className="recommend-logo">
                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/title-lottery.png" alt="" />
                            </div>
                            <div className="recommend-center-img">
                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/lottery.png" alt="" />
                            </div>
                            <span className="recommend-text">
                                Tất cả các chiến thắng trong vòng quay miễn phí sẽ trả x3 và 10 dòng trả tiền cũng như 3 vòng quay bắt đầu kho báu trở lên.
                            </span>
                        </div>
                        <img className="recommend-game-bg carousel-item" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/bg-sport.png" alt="" />
                    </Link>
                </SwiperSlide>
                
                <SwiperSlide className="recommend-wrapper">
                    <Link >
                        <div className="recommend-content">
                            <div className="recommend-logo">
                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/title-poker.png" alt="" />
                            </div>
                            <div className="recommend-center-img">
                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/poker.png" alt="" />
                            </div>
                            <span className="recommend-text">
                                Người chơi có thể chọn từ Wild Wilds, Nudge Reels hoặc Synced Reels làm phần thưởng bổ sung.
                            </span>
                        </div>
                        <img className="recommend-game-bg carousel-item" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/bg-sport.png" alt="" />
                    </Link>
                </SwiperSlide>
                
                <SwiperSlide className="recommend-wrapper">
                    <Link>
                        <div className="recommend-content">
                            <div className="recommend-logo">
                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/title-keno.png" alt="" />
                            </div>
                            <div className="recommend-center-img">
                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/keno.png" alt="" />
                            </div>
                            <span className="recommend-text">
                                Chơi game với hệ số nhân và tỷ lệ cược cao để phù hợp với nhu cầu và thói quen của người chơi châu Á.
                            </span>
                        </div>
                        <img className="recommend-game-bg carousel-item" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slide/bg-sport.png" alt="" />
                    </Link>
                </SwiperSlide>
            </Swiper>

            <div className="recommend-button-prev"></div>
            <div className="recommend-button-next"></div>
            <span className="swiper-notification"></span>
        </div>
    </div>
    
    <ul className="recommend-games">
        <li className="recommend-game-items">
            <span className="slots-new-text">Đặt cược ngay</span>
            <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/sport.png" alt="" />
            <div className="recommend-game-text">
                <span>THỂ THAO</span>
                <div className="recommend-btn-wrapper">
                    <div className="recommend-button">
                        <Link className="play-btn btn" to="/sports">Chơi ngay</Link>
                    </div>
                    <div className="recommend-text-wrapper">
                        <span>THỂ THAO</span>
                        <div className="recommend-game-wrapper"></div>
                    </div>
                </div>
            </div>
        </li>
        <li className="recommend-game-items">
            <span className="slots-new-text">Đặt cược ngay</span>
            <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/casino.png" alt="" />
            <div className="recommend-game-text">
                <span>CASINO TRỰC TIẾP</span>
                <div className="recommend-btn-wrapper">
                    <div className="recommend-button">
                        <Link className="play-btn btn" to="/casino">Chơi ngay</Link>
                    </div>
                    <div className="recommend-text-wrapper">
                        <span>CASINO TRỰC TIẾP</span>
                        <div className="recommend-game-wrapper"></div>
                    </div>
                </div>
            </div>
        </li>
        <li className="recommend-game-items">
            <span className="slots-new-text">Đặt cược ngay</span>
            <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot.png" alt="" />
            <div className="recommend-game-text">
                <span>SLOTS</span>
                <div className="recommend-btn-wrapper">
                    <div className="recommend-button">
                        <Link className="play-btn btn" to="/slots">Chơi ngay</Link>
                    </div>
                    <div className="recommend-text-wrapper">
                        <span>SLOTS</span>
                        <div className="recommend-game-wrapper"></div>
                    </div>
                </div>
            </div>
        </li>
        <li className="recommend-game-items">
            <span className="slots-new-text">Đặt cược ngay</span>
            <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/lottery.png" alt="" />
            <div className="recommend-game-text">
                <span>LOTTERY</span>
                <div className="recommend-btn-wrapper">
                    <div className="recommend-button">
                        <Link className="play-btn btn" to="/lottery">Chơi ngay</Link>
                    </div>
                    <div className="recommend-text-wrapper">
                        <span>LOTTERY</span>
                        <div className="recommend-game-wrapper"></div>
                    </div>
                </div>
            </div>
        </li>
        <li className="recommend-game-items">
            <span className="slots-new-text">Đặt cược ngay</span>
            <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/number.png" alt="" />
            <div className="recommend-game-text">
                <span>TRÒ CHƠI</span>
                <div className="recommend-btn-wrapper">
                    <div className="recommend-button">
                        <Link className="play-btn btn" to="/sicbo">Chơi ngay</Link>
                    </div>
                    <div className="recommend-text-wrapper">
                        <span>TRÒ CHƠI</span>
                        <div className="recommend-game-wrapper"></div>
                    </div>
                </div>
            </div>
        </li>
        <li className="recommend-game-items">
            <span className="slots-new-text">Đặt cược ngay</span>
            <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/poker.png" alt="" />
            <div className="recommend-game-text">
                <span>GAME BÀI</span>
                <div className="recommend-btn-wrapper">
                    <div className="recommend-button">
                        <Link className="play-btn btn" to="/pvp">Chơi ngay</Link>
                    </div>
                    <div className="recommend-text-wrapper">
                        <span>GAME BÀI</span>
                        <div className="recommend-game-wrapper"></div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</div>
                        </div>
                    </div>
                </div>

                <div className="mini-games-wrapper">
                    <h2 className="t-game">Trò chơi thú vị và phổ biến nhất là ở đây</h2>
                    <div className="game-list-wrapper">
                        {/* --- FIX 2: BỌC BOTTOM SLOTS BẰNG REACT SWIPER --- */}
                        <Swiper {...swiperGame5} className="game-list">  
                            <SwiperSlide>
                                <Link className="game-list-img">
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/afb.png" alt="" />
                                    <div className="game-home">AFB GAMING</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/fishing.png" alt="" />
                                    <div className="game-home">FISHING GAMES</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/pplay.png" alt="" />
                                    <div className="game-home">PPLAY SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/hb.png" alt="" />
                                    <div className="game-home">HABA SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img">
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/playstar.png" alt="" />
                                    <div className="game-home">PLAYSTAR SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img">
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/dragoon.png" alt="" />
                                    <div className="game-home">DRAGOON SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/pg.png" alt="" />
                                    <div className="game-home">PG SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/cq9.png" alt="" />
                                    <div className="game-home">CQ9 SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img">
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/fc.png" alt="" />
                                    <div className="game-home">FC SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img">
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/jili.png" alt="" />
                                    <div className="game-home">JILI SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/kaslots.png" alt="" />
                                    <div className="game-home">KA GAMING</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/rich88.png" alt="" />
                                    <div className="game-home">Rich88 SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/spadegaming.png" alt="" />
                                    <div className="game-home">SPADEGAMING</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/platipus.png" alt="" />
                                    <div className="game-home">PLATIPUS SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/nextspin.png" alt="" />
                                    <div className="game-home">NEXTSPIN SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/live22.png" alt="" />
                                    <div className="game-home">LIVE22 SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/rtg.png" alt="" />
                                    <div className="game-home">RED TIGER</div>
                                </Link>
                            </SwiperSlide>
                                <SwiperSlide>
                                    <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/nlc.png" alt="" />
                                    <div className="game-home">NLC SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img">
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/netent.png" alt="" />
                                    <div className="game-home">NETENT GAMING</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/btg.png" alt="" />
                                    <div className="game-home">BTG SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/png.png" alt="" />
                                    <div className="game-home">PLAY & GO</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/relax.png" alt="" />
                                    <div className="game-home">RELAX SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/genesis.png" alt="" />
                                    <div className="game-home">GENESIS SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img">
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/hacksaw.png" alt="" />
                                    <div className="game-home">HACKSAW SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img">
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/cg.png" alt="" />
                                    <div className="game-home">CG SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/ap.png" alt="" />
                                    <div className="game-home">AP SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/bp.png" alt="" />
                                    <div className="game-home">BIGPOT SLOTS</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/fastspin.png" alt="" />
                                    <div className="game-home">FASTSPIN</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/kmslots.png" alt="" />
                                    <div className="game-home">KING MAKER</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/play8.png" alt="" />
                                    <div className="game-home">PLAY8</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/yesbingo.png" alt="" />
                                    <div className="game-home">YESBINGO</div>
                                </Link>
                            </SwiperSlide>
                            <SwiperSlide>
                                <Link className="game-list-img" >
                                    <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/home/slot/ylslots.png" alt="" />
                                    <div className="game-home">YL GAMING</div>
                                </Link>
                            </SwiperSlide>
                        </Swiper>  
                    </div>
                </div>
            </main>
        </>
    );
}
export default Home;